module.exports = __webpack_public_path__ + "static/media/bg_gradient.75c6107e.jpg";